import i18n from 'i18n-literally'
import { createSelector } from 'redux-bundler'

import { humanize } from 'inflection'

// import config from '~/src/App/config'
import createEntityBundle from '~/src/Lib/createEntityBundle'
import createLogger from '~/src/Lib/Logging'
import { EMPTY_OBJECT } from '~/src/Lib/Utils'
import { Membership as schema } from '~/src/Store/Schemas'

import { prepareData } from './shape'

const name = 'memberships'
const logger = createLogger(name)

const initialBundle = createEntityBundle({
  name,
  apiConfig: {
    prepareData,
    schema,
    snackbar: ({ status, dispatch, action }) => {
      if (action === 'fetch') return
      dispatch({
        actionCreator: 'doAddSnackbarMessage',
        // TODO: convert the humanize to use i18n
        args: [i18n`Account ${humanize(action)} ${status}ed`],
      })
    },
  },
})
const bundle = {
  ...initialBundle,
  selectFacilityMemberships: createSelector(
    'selectCurrentFacility',
    'selectMemberships',
    (currentFacility, allMemberships) => {
      const { id: facilityId } = currentFacility ?? EMPTY_OBJECT
      if (!facilityId) return EMPTY_OBJECT

      return Object.values(allMemberships).reduce(
        (acc, membership) => (membership.facility === facilityId ? { ...acc, [membership.id]: membership } : acc),
        EMPTY_OBJECT,
      )
    },
  ),
  selectBillingContact: createSelector('selectFacilityMemberships', 'selectUsers', (facilityMemberships, users) => {
    const billingContactMembership = Object.values(facilityMemberships).find(m => m.isApContact)
    return users[billingContactMembership?.user] ?? null
  }),
  doSetPhoneAsDefault:
    id =>
    async ({ store, apiFetch }) => {
      try {
        await apiFetch(`/phones/${id}/setAsDefault/`, null, { method: 'POST' })
        store.doAddSnackbarMessage(i18n`Successfully set phone as default.`)
        await store.doFetchMe()
      } catch {
        store.doAddSnackbarMessage(i18n`Failed to set phone as default.`)
      }
    },
  doResendPhoneCode:
    id =>
    async ({ store, apiFetch }) => {
      try {
        await apiFetch(`/phones/${id}/resendCode/`, null, { method: 'GET' })
        await store.doFetchMe()
      } catch {
        store.doAddSnackbarMessage(i18n`Failed to resend confirmation code.`)
      }
    },
  doCheckConfirmationCode:
    payload =>
    async ({ store, apiFetch }) => {
      try {
        await apiFetch(`/phones/${payload.id}/confirm/`, payload.code, { method: 'POST' })
        await store.doFetchMe()
        return {
          status: 200,
          message: 'Success',
        }
      } catch {
        store.doAddSnackbarMessage(i18n`Incorrect Confirmation Code`)
        return {
          status: 400,
          message: 'Failed',
        }
      }
    },
}

export default bundle
